import { render, staticRenderFns } from "./CardComm.vue?vue&type=template&id=bcf4b0de&scoped=true&"
import script from "./CardComm.vue?vue&type=script&lang=js&"
export * from "./CardComm.vue?vue&type=script&lang=js&"
import style0 from "./CardComm.vue?vue&type=style&index=0&id=bcf4b0de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf4b0de",
  null
  
)

export default component.exports